import NextLink from 'next/link';

import { Button, Caption, Container, Link, SectionText } from '@/atoms';
import { Card, SwiperCustom } from '@/molecules';

import type { FunctionComponent } from 'react';
import type { TypeGeneralCardsProps } from './types';

/**
 * GeneralCards
 */
export const GeneralCards: FunctionComponent<TypeGeneralCardsProps> = ({
  className = '',
  caption,
  cardsProps,
  textColor,
  title,
  id,
  index,

  ...props
}: TypeGeneralCardsProps) => (
  <Container
    id={id}
    overflows
    index={index}
    className={`flex flex-col gap-14 ${className}`}
    {...props}
  >
    <SectionText
      title={title}
      variant={textColor}
      direction="row"
      textAlign="start"
      caption={caption}
    />
    <SwiperCustom
      className="w-full"
      gap={30}
      slidesPerView={3.5}
      slidesPerViewMobile={1}
      navigation
      scrollbar
    >
      {cardsProps.map((card: any, index: number) => (
        <Card
          key={index}
          className=" h-full"
          classNames={{ content: 'flex flex-col justify-between gap-3 h-full' }}
          multimediaProps={{ image: card.image }}
        >
          <div className="flex flex-col gap-2">
            {card.caption && <Caption>{card.caption}</Caption>}
            <h4>{card.title}</h4>
            {card.desc && <span>{card.desc}</span>}
          </div>
          <div>
            {card?.button?.src && card?.button?.label && (
              <div className="w-1/2">
                <NextLink href={card.button.src} passHref prefetch={false}>
                  <Button as="a" size="large" variant={card.button.variant}>
                    {card.button.label}
                  </Button>
                </NextLink>
              </div>
            )}

            {card?.link?.src && card?.link?.label && (
              <NextLink href={card.link.src} passHref prefetch={false}>
                <Link variant="primary">{card.link.label}</Link>
              </NextLink>
            )}
          </div>
        </Card>
      ))}
    </SwiperCustom>
  </Container>
);

GeneralCards.displayName = 'GeneralCards';
